/**
 * Wrapper для Route с проверкой прав доступа к модулю
 */
import React from 'react';
import PermissionGuard from '@/components/PermissionGuard';

interface ProtectedModuleRouteProps {
  children: React.ReactNode;
  module: string;
  action?: 'view' | 'create' | 'edit' | 'delete';
}

/**
 * Обертка для роутов с проверкой прав доступа
 * Если доступа нет, показывает сообщение об отказе
 */
const ProtectedModuleRoute: React.FC<ProtectedModuleRouteProps> = ({
  children,
  module,
  action = 'view',
}) => {
  return (
    <PermissionGuard module={module} action={action} showDeniedMessage={true}>
      {children}
    </PermissionGuard>
  );
};

export default ProtectedModuleRoute;
